var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLoggedIn)?_c('navigation-drawer',{attrs:{"items":_vm.items}}):_vm._e(),(_vm.isLoggedIn)?_c('notification-container'):_vm._e(),_c('v-main',{staticClass:"main"},[_c('div',{staticClass:"content"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }